import React from 'react'
import { connect } from 'react-redux'
import { isMobile } from 'react-device-detect'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { withRouter } from 'react-router-dom'
import { FormattedMessage, injectIntl } from 'react-intl'
import { ButtonLink } from 'core/components/ui'

import { font, greys, fontFamily } from 'assets/themes/theme-default'
import configurationShape from '../../../configuration/shapes'

const Content = styled.div`
  max-width: 1300px;
  margin: 0 auto;
  position: relative;
  bottom: 0;
  padding: ${isMobile ? '10px 20px 70px 20px' : '10px 30px 80px 30px;'};
  font-size: ${font.size.xs};
  line-height: ${font.size.sm};
  color: ${greys.dark3};
  font-family: ${props => props.theme.fontFamily && `${props.theme.fontFamily.italic.name},`}
    ${fontFamily.italic};
`
const ButtonStyled = styled(ButtonLink)`
  &&& span {
    font-size: ${font.size.xs};
  }
`

const Footer = props => {
  const { configuration, privacyPolicy } = props

  const { campaign } = configuration

  function createFooter() {
    return { __html: campaign.theme.footer }
  }

  const getDPOName = () => {
    if (!privacyPolicy) {
      return ''
    }
    if (privacyPolicy.entity) {
      return privacyPolicy.entity.name
    }
    return privacyPolicy.entityGroup.name
  }

  return campaign && campaign.theme.footer ? (
    // eslint-disable-next-line react/no-danger
    <div dangerouslySetInnerHTML={createFooter()} />
  ) : (
    <Content>
      <FormattedMessage id="footer-text-1" />
      <br />
      <FormattedMessage
        id="footer-text-2"
        values={{
          DPOName: getDPOName()
        }}
      />
      {privacyPolicy && privacyPolicy.email ? (
        <>
          :{' '}
          <ButtonStyled
            style={{ height: 'auto' }}
            type="link"
            href={`mailto: ${privacyPolicy.email}`}
          >
            {privacyPolicy.email}
          </ButtonStyled>
        </>
      ) : (
        '.'
      )}
      <br />
      {privacyPolicy && privacyPolicy.url && (
        <>
          <FormattedMessage id="footer-text-3" />{' '}
          <ButtonStyled
            target="_blank"
            style={{ height: 'auto' }}
            type="link"
            href={privacyPolicy.url}
          >
            <FormattedMessage id="footer-button-1" />
          </ButtonStyled>{' '}
          <FormattedMessage id="footer-text-4" />
        </>
      )}
    </Content>
  )
}

Footer.propTypes = {
  configuration: configurationShape.isRequired,
  privacyPolicy: PropTypes.shape().isRequired
}

const mapStateToProps = state => ({
  configuration: state.configuration,
  privacyPolicy: state.configuration.privacyPolicy
})

export default connect(mapStateToProps, null)(withRouter(injectIntl(Footer)))
